import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./scss/index.scss";
import * as React from "react";
import { useIntl } from "react-intl";
import { useAuth } from "@saleor/sdk";
import { demoMode } from "@temp/constants";
import { commonMessages } from "@temp/intl";
import { Button, Form, TextField } from "..";

var LoginForm = function LoginForm(_ref) {
  var hide = _ref.hide;

  var _useAuth = useAuth(),
      signIn = _useAuth.signIn;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      loading = _React$useState2[0],
      setLoading = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      errors = _React$useState4[0],
      setErrors = _React$useState4[1];

  var handleOnSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(evt, _ref2) {
      var email, password, _yield$signIn, data, dataError;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              email = _ref2.email, password = _ref2.password;
              evt.preventDefault();
              setLoading(true);
              _context.next = 5;
              return signIn(email, password);

            case 5:
              _yield$signIn = _context.sent;
              data = _yield$signIn.data;
              dataError = _yield$signIn.dataError;
              setLoading(false);

              if (dataError === null || dataError === void 0 ? void 0 : dataError.error) {
                setErrors(dataError.error);
              } else if (data && hide) {
                setErrors(null);
                hide();
              }

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleOnSubmit(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  var formData = demoMode ? {
    email: "admin@example.com",
    password: "admin"
  } : {};
  var intl = useIntl();
  return React.createElement("div", {
    className: "login-form"
  }, React.createElement(Form, {
    data: formData,
    errors: errors || [],
    onSubmit: handleOnSubmit
  }, React.createElement(TextField, {
    name: "email",
    autoComplete: "email",
    label: intl.formatMessage(commonMessages.eMail),
    type: "email",
    required: true
  }), React.createElement(TextField, {
    name: "password",
    autoComplete: "password",
    label: intl.formatMessage(commonMessages.password),
    type: "password",
    required: true
  }), React.createElement("div", {
    className: "login-form__button"
  }, React.createElement(Button, _extends({
    testingContext: "submit",
    type: "submit"
  }, loading && {
    disabled: true
  }), loading ? intl.formatMessage(commonMessages.loading) : intl.formatMessage(_defineProperty({
    defaultMessage: "Sign in",
    "id": "components.LoginForm.index.1405865627"
  }, "id", "components.LoginForm.index.1405865627"))))));
};

export default LoginForm;